// redex/users/reportApi.js
import api from "../../utils/api";
import { apiPath } from "../../utils/apiPath";
import { showApiErrorToast } from "../../utils/toastErrorHandler";




export async function reportListsApi(payload) {
  return await api.get(
    `${apiPath.API_URL}${apiPath.report.reportList}`,
    { params: payload } 
  );
}

export async function userReportListsApi(payload) {
  return await api.get(
    `${apiPath.API_URL}${apiPath.report.userReportList}`,
    { params: payload } 
  );
}


export async function excelClientWiseReportCountApi(payload) {
  return await api.get(
    `${apiPath.API_URL}${apiPath.report.excelClientWiseReportCount}`,
    { params: payload } 
  );
}

/* The Daily Management Report's other two tables. Plain gets — the work is
   all in the procedures behind them. */
export async function fetchStaffAttendanceApi(payload) {
  return await api.get(`${apiPath.API_URL}${apiPath.report.staffAttendance}`, {
    params: payload,
  });
}

export async function fetchClientQueryStatusApi(payload) {
  return await api.get(`${apiPath.API_URL}${apiPath.report.clientQueryStatus}`, {
    params: payload,
  });
}
